import {
  Button,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Skeleton,
  Checkbox,
  ListItemText,
  Typography,
  Box,
  Tooltip,
} from '@mui/material';
import React, { useEffect, useState, Fragment } from 'react';
import './../../influencer/settings/personal-info/personal_info.scss';
import SampleProfile from '../../../assets/images/avtar_male.png';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import { FormValidation, Methods } from '../../../core/utility';

import {
  LocalService,
  PublicService,
  UserService,
} from '../../../core/services';
import { Loading } from '../../../redux/action';
import { connect, useDispatch } from 'react-redux';
// import { Security } from '../../common/security/security'
import { ImageCrop } from '../../../components';
import { UserLogin } from '../../../redux/action';
import FileUploadPopup from '../../../components/popup/file-upload-popup';
import { DefaultUserProfile } from '../../../config/config';
import { MenuPropsSelect } from '../../../core/utility/style';
import * as gtUtil from "../../../core/utility";
import MaterialSymbol from '../../../components/icons/material-symbol';


// Create an instance of LocalService class
const localService: LocalService = new LocalService();
// Create an instance of UserService class
const userService: UserService = new UserService();
// Create an instance of publicService class
const publicService: PublicService = new PublicService();
// To use predefined methods, to calculate age and get formatted date
const platformMethod = new Methods();

interface Props {
  loading: (data: any) => any;
  userData: any;
  updateAccountImage: (data: any) => void;
}

const UserPersonalInfo: React.FC<Props> = (props: Props) => {
  const [disableField, setDisableField] = useState(true);
  const [buttonName, setButtonName] = useState('Edit');
  const [cameraIcon, setCameraIcon] = useState(false);
  const [showUploadPopup, setShowUploadPopup] = useState<any>(false);
  const [selectedIndustries, setSelectedIndustries] = useState<any>("");
  const [industryList, setIndustryList] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false)
  const path = `accounts/${props.userData.account_id}/users`
  const [_industry, setIndustry] = useState<any>("");
  const [selectedIndustry, setSelectedIndustry] = useState<string[]>([]);
  const [otherText, setOtherText] = useState('');
  const [openSelect, setOpenSelect] = useState(false);
  const [industryData, setIndustryData] = useState<any[]>([]);

  // Create new instance from FormValidation class
  const formValidation = new FormValidation();

  // Set form fields
  const [formData, setFormData] = useState<any>({
    user_id: props.userData.user_id,
    brand_id: props.userData.brand_id,
    account_id: props.userData.account_id,
    influencer_id: props.userData.influencer_id,
    account_type: props.userData.account_type,
    full_name: '',
    login_mobile: '',
    login_email: '',
    photo: '',
    image_path: '',
    mobile_verified: '',
    email_verified: '',
    industry_id: ''
  });

  // Set form error fields
  const [formError, setFormErrors] = useState<any>({
    full_name: { status: true, message: '' },
    photo: { status: true, message: '' },
    industry: { status: true, message: '' },
    other_text: { status: true, message: '' },
  });

  useEffect(() => {
    // props.loading(true);
    getUserDetails();

  }, []);

  useEffect(() => {
    // props.loading(true);
    PublicService.industryList()
      .then((res) => {
        setIndustryList(res?.data?.rows);
        props.loading(false);
      })
      .catch((error) => {
        props.loading(false);
        console.log(
          `Brand industryList error :: ${JSON.stringify(error)}`
        );
      });
  }, []);


  async function getUserDetails() {
    setLoading(true);
    try {
      const response = await userService.getUserDetails(`${props.userData.user_id}`);
      if (response.data.status) {
        const userData = response.data.rows[0];
  
        // Update form data
        setFormData((prevFormData : any) => ({
          ...prevFormData,
          ...userData
        }));
  
        // Handle industry and sub-industry selection
        const primaryId = String(userData.industry_id);
        const rawSubIds = userData.sec_industry_id
          ? [...new Set(userData.sec_industry_id.split(',').map((id: any) => id.trim()))]
          : [];
  
        let formattedSelected: string[] = [];
  
        if (rawSubIds.length > 0) {
          formattedSelected = rawSubIds.map((subId) => `${primaryId}_${subId}`);
        } else {
          formattedSelected = [primaryId];
        }
  
        setSelectedIndustry(formattedSelected);
  
        // Handle brand_category conditionally
        if (primaryId === '27') {
          setOtherText(userData.brand_category || '');
        } else {
          setOtherText('');
        }
      }
    } catch (error) {
      console.log(`getUserDetails error :: ${JSON.stringify(error)}`);
    } finally {
      props.loading(false);
      setLoading(false);
    }
  }
  

  // Submit form logic
  const handleUserInfoFormData = async (e: any) => {
    try {
      e.preventDefault();
      // Validate form
      // validating name
      const validateName = formValidation.GetNameValidate(
        formData.full_name
      );
      const validateImage = formValidation.GetNameValidate(
        formData.photo
      );
      const validateIndustry = formValidation.GetSelectFieldValidateArray(
        selectedIndustry
      );

      let validateOtherText: any;
      if (selectedIndustry.includes('27')) {
        validateOtherText = formValidation.GetNameValidate(otherText);
      }

      setFormErrors({
        full_name: { ...validateName },
        photo: { ...validateImage },
        industry: { ...validateIndustry },
        other_text: { ...validateOtherText },
      });
      if (buttonName === 'Edit') {
        setButtonName('Update');
        setDisableField(false);
        setCameraIcon(true)
      }
      else if (validateName.status && validateIndustry.status) {
        try {
          props.loading(true);
          const payload = {
            ...formData,
            industry: selectedIndustry,
            brand_category: otherText,
          };
          const res = await userService.updateUserInfo(payload);
          if (res.data.status) {
            // to update image in props
            props.updateAccountImage({ ...props.userData, ...formData });
            let localData = localService.getStorageItem('userreducer');
            if (localData) {
              localData = { ...JSON.parse(localData), ...formData };
              localService.setStorageItem('userreducer', JSON.stringify(localData));
            }
            setButtonName('Edit');
            setDisableField(true);
            setCameraIcon(false);
            localService.toastify(res.data.message, 'success', 1000);
          }
          else {
            localService.toastify(res.data.message, 'error', 1000);
          }

          // Remove loader
          props.loading(false);

          return res.data.rows;
        } catch (error) {
          // Remove loader
          props.loading(false);
          throw new Error(`Handle Personal Info Save Error :: ${error}`);
        }
      }
    } catch (error) {
      // Remove loader
      props.loading(false);
      throw new Error(
        `Influencer Account Update function error :: ${JSON.stringify(error)}`
      );
    }
  }

  const handleError = (event: any) => {
    const validateName = formValidation.GetNameValidate(
      formData.full_name
    );
    const validateImage = formValidation.GetNameValidate(
      formData.photo
    );
    setFormErrors({
      full_name: { ...validateName },
      photo: { ...validateImage }
    });
  }

  const handlePhoto = (photo_url: any) => {
    // set uploaded photo in formData
    setFormData({
      ...formData,
      photo: photo_url,
    })
  }

  //*Industry Select Change

  const handleIndustryChange = (e: any) => {
    const {
      target: { value },
    } = e;
    setFormData({
      ...formData,
      industry_id: value
    });
  };

   async function getSecIndustryList() {
      try {
        const response = await publicService.getSecondaryIndustryList()
        if (response?.data?.status === gtUtil.Constants.SUCCESS) {
          const rows = response.data.rows;
  
          const grouped = Object.values(
            rows.reduce((acc:any, item:any) => {
              const industryId = item.industry_id.toString();
  
              if (!acc[industryId]) {
                acc[industryId] = {
                  id: industryId,
                  name: item.industry,
                  sub: [],
                };
              }
  
              if (item.sec_industry_id && item.sec_industry) {
                acc[industryId].sub.push({
                  id: `${industryId}_${item.sec_industry_id}`,
                  name: item.sec_industry,
                  industry_id: industryId,
                  sec_industry_id: item.sec_industry_id,
                });
              }
  
              return acc;
            }, {} as Record<string, any>)
          );
  
          setIndustryData(grouped);
        } else {
          setIndustryData([]);
        }
      } catch (error) {
        console.error('getSecIndustryList :::', error);
        setIndustryData([]);
      }
    }
  
    useEffect(() => {
      getSecIndustryList();
    }, []);
  
  
    const handlePrimaryClick = (primaryId: string, subList: any[]) => {
      if (!subList.length) {
        // No sub-industries: toggle the primary directly
        setSelectedIndustry((prev) =>
          prev.includes(primaryId) ? prev.filter((id) => id !== primaryId) : [primaryId]
        );
        setOpenSelect(false);
      } else {
        const allSubIds = subList.map((sub) => sub.id);
        const isSelected = allSubIds.every((id) => selectedIndustry.includes(id));
        setSelectedIndustry(isSelected ? [] : allSubIds);
      }
      if (!selectedIndustry.includes("27")) {
        setOtherText('')
      }
    };
  
    
    const handleSecondaryClick = (id: string) => {
      const [industryId] = id.split('_');
      const existingIndustryIds = selectedIndustry.map((sid) =>
        sid.includes('_') ? sid.split('_')[0] : sid
      );
      const isSameIndustry = existingIndustryIds.every((iid) => iid === industryId);
    
      if (!isSameIndustry) {
        setSelectedIndustry([id]);
      } else {
        setSelectedIndustry((prev) =>
          prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
      }
       if (existingIndustryIds.includes("27") && !isSameIndustry) {
        setOtherText('')
      }
    };

  return (
    <Fragment>
      <form onSubmit={handleUserInfoFormData} className='mb-4'>
        <div className='p-0  _influencer_setting_personal_info_main'>
          <div className='list-section-content rounded'>
              <strong className=''>Personal Information</strong>
              <div className='col-auto text-end'>
                <Button
                  size='small'
                  type='submit'
                  variant='contained'
                  className='btn btn-primary btn-mui btn-lg'
                >
                  {buttonName}
                </Button>
            </div>
          </div>
          <div>
            <div className='row mb-3'>
              <div className='col-auto _influencer_setting_img'>
                {loading ? <Skeleton variant="circular" height={100} width={100} /> :
                <> {cameraIcon ? <img
                  onClick={() => { setShowUploadPopup(!showUploadPopup) }}
                    src={formData.photo === ''
                      ? DefaultUserProfile.influencer_unknown_default
                      : formData.photo}
                    alt="User"
                    style={{ position: "relative", cursor:'pointer' }}
                  /> : <img 
                    src={formData.photo === ''
                      ? DefaultUserProfile.influencer_unknown_default
                      : formData.photo}
                    alt="User"
                    style={{ position: "relative" }
                    } />
                  }
                  </>
                }

                {cameraIcon && <AddAPhotoIcon className='add-photo-icon'
                  onClick={() => { setShowUploadPopup(!showUploadPopup) }} />}

                <div className='col-lg-3 '>
                  {showUploadPopup && (
                    <FileUploadPopup openModal={showUploadPopup} onClose={(e) => setShowUploadPopup(false)} onSend={(e) => handlePhoto(e.url)}
                      path={path}
                      acceptedFileTypes=".jpg, .jpeg, .png" />
                  )}
                </div>

              </div>
              <div className='col'>
                {loading ? <Skeleton height={40} /> : 
                <TextField
                  className='input-common'
                  fullWidth
                  label='Name'
                  name='full_name'
                  variant='standard'
                  value={formData?.full_name}
                  disabled={disableField}
                  error={!formError?.full_name?.status}
                  helperText={
                    formError?.full_name?.message
                  }
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      full_name: e.target.value,
                    })
                  }
                  onBlur={handleError}
                />
              }
              </div>
            </div>
          </div>
          <Grid container rowSpacing={2} spacing={2}>
            <Grid item xs={12} md={6}>
              {loading ? <Skeleton height={40} /> : <TextField
                className='influencer_personal_info input-common'
                size='small'
                fullWidth
                name='login_email'
                type='email'
                label='Email'
                variant='outlined'
                defaultValue={formData?.login_email}
                disabled={true}
                key={formData?.login_email}
              />}
            </Grid>
            <Grid item xs={12} md={6}>
              {loading ? <Skeleton height={40} /> : <TextField
                className='influencer_personal_info input-common'
                size='small'
                fullWidth
                name='login_mobile'
                type='number'
                label='Mobile'
                variant='outlined'
                defaultValue={formData?.login_mobile}
                disabled={true}
                key={formData?.login_mobile}
              />}
            </Grid>
            <Grid item xs={12} md={6}>
              {loading ? <Skeleton height={40} /> : <TextField
                className='influencer_personal_info input-common'
                size='small'
                fullWidth
                name='email_verified'
                label='Email verified'
                variant='outlined'
                defaultValue={formData?.email_verified}
                disabled={true}
                key={formData?.email_verified}
              />}
            </Grid>
            <Grid item xs={12} md={6}>
              {loading ? <Skeleton height={40} /> : <TextField
                className='influencer_personal_info input-common'
                size='small'
                fullWidth
                name='mobile_verified'
                label='Mobile verified'
                variant='outlined'
                defaultValue={formData?.mobile_verified}
                disabled={true}
                key={formData?.mobile_verified}
              />}
            </Grid>
            <Grid item xs={12} md={12}>
              {/* {loading ? <Skeleton height={40} /> : <FormControl fullWidth size='small'>
                <InputLabel id='my-select-label'>Industry</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Industry Type"
                  disabled={disableField}
                  defaultValue={formData.industry_id}
                  key={formData.industry_id}
                  name="industry"
                  onChange={handleIndustryChange}
                  MenuProps={MenuPropsSelect}
                >
                  {industryList && industryList.length > 0 ? (
                    industryList.map((res: any) => {
                      return (
                        <MenuItem
                          key={res.industry_id}
                          id={res.industry_id}
                          value={res.industry_id}
                        >
                          {res.industry}
                        </MenuItem>
                      );
                    })
                  ) : (
                    <MenuItem>No Data</MenuItem>
                  )}
                </Select>
              </FormControl>} */}
              {loading ? <Skeleton height={40} /> :
                <div className="col">
                  <FormControl fullWidth size="small" className="input-common input-style">
                    <InputLabel id='my-select-label'>Industry Type</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      multiple
                      label="Industry Type"
                      disabled={disableField}
                      className='industry-dropdown-container'
                      open={openSelect}
                      onClose={() => setOpenSelect(false)}
                      onOpen={() => setOpenSelect(true)}
                      value={selectedIndustry}
                      MenuProps={{
                        PaperProps: {
                          className: openSelect ? 'industry-dropdown-modal open' : 'industry-dropdown-modal',
                        },
                      }}
                      renderValue={(selectedIds) => {
                        if (!selectedIds.length) return '';

                        const selectedId = selectedIds[0];
                        const isTopLevel = !selectedId.includes('_');

                        if (isTopLevel) {
                          const industry = industryData.find((ind) => ind.id === selectedId);
                          return industry?.name || '';
                        }

                        const [industryId] = selectedId.split('_');
                        const industry = industryData.find((ind) => ind.id === industryId);
                        const names = selectedIds
                          .map((id) => {
                            const sub = industry?.sub?.find((s: any) => s.id === id);
                            return sub?.name;
                          })
                          .filter(Boolean);
                        return `${industry?.name}: ${names.join(', ')}`;
                      }}
                    >
                      {industryData.map((main) => (
                        <div className="industry-dropdown-list" key={main.id}>
                          <MenuItem className='industry-main'
                            onClick={() =>
                              handlePrimaryClick(main.id, main.sub?.length ? main.sub : [])
                            }
                          >
                            <Checkbox
                              checked={
                                main.sub?.length
                                  ? main.sub.every((sub: any) => selectedIndustry.includes(sub.id))
                                  : selectedIndustry.includes(main.id)
                              }
                            />
                            
                            <ListItemText className={`${main.name === 'Lifestyle' ? "industry-main-w-tooltip " : ""}`}
                              primary={
                              <><Typography className='d-flex align-items-center' fontWeight="bold">
                                {main.name}
                               {main.name === 'Lifestyle' && 
                                <><Tooltip arrow className='industry-main-w-tooltip-text' title="Brands that promote a lifestyle and sell products and services that help people achieve it"><span><MaterialSymbol fontSize='20px' iconName='info' fontweight='200' /></span></Tooltip></>
                              } 
                              </Typography>
                             
                              </>}
                            />
                            
                          </MenuItem>

                          {main.sub?.length > 0 &&
                            main.sub.map((sub: any) => (
                              <MenuItem className='industry-submain'
                                key={sub.id}
                                sx={{ pl: 4 }}
                                onClick={() => handleSecondaryClick(sub.id)}
                              >
                                <Checkbox checked={selectedIndustry.includes(sub.id)} />
                                <ListItemText primary={sub.name} />
                              </MenuItem>
                            ))}
                        </div>
                      ))}
                    </Select>
                  </FormControl>
                  <span className="error">{formError.industry?.message}</span>
                  {(selectedIndustry.includes('27') || otherText) && (
                    <Box mt={2}>
                      <TextField
                        fullWidth
                        disabled={disableField}
                        label="Please specify Industry"
                        value={otherText}
                        // onChange={(e) => setOtherText(e.target.value)}
                        onChange={(e) => {
                          const value = e.target.value;
                          setOtherText(value);

                          // Clear error when typing valid value
                          if (value.trim() !== '') {
                            setFormErrors((prev:any) => ({
                              ...prev,
                              other_text: { status: true, message: '' },
                            }));
                          }
                        }}
                        size="small"
                      />
                      <span className="error">{formError.other_text?.message}</span>
                    </Box>
                  )}
                </div>}
            </Grid>
          </Grid>
        </div>
      </form>
      {/* <Security /> */}
    </Fragment>
  );
};

const mapStateToProps = (state: any) => {
  return {
    userData: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
    updateAccountImage: (data: any) => dispatch(UserLogin(data))
  };
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserPersonalInfo);
export { connectToRedux as UserPersonalInfo };
